import React from "react";

const Tabs = React.forwardRef(
  (
    { className, style, variant, stacked, value, onChange, children, ...rest },
    ref,
  ) => {
    const classes = ["ta-tabs", stacked ? "ta-tabs--stacked" : "", className]
      .filter(Boolean)
      .join(" ");

    const modifiedChildren = React.Children.map(children, (child, index) => {
      if (!React.isValidElement(child)) {
        return child;
      }

      const childValue =
        child.props.value !== undefined ? child.props.value : index;
      const isSelected = value === childValue;

      return React.cloneElement(child, {
        selected: isSelected,
        onClick: (e) => {
          if (!child.props.disabled && onChange) {
            onChange(childValue, e);
          }
          if (child.props.onClick) {
            child.props.onClick(e);
          }
        },
      });
    });

    return (
      <div
        ref={ref}
        data-variant={variant}
        className={classes}
        style={style}
        role="tablist"
        {...rest}
      >
        {modifiedChildren}
      </div>
    );
  },
);

export default Tabs;
